import { useCallback, useEffect } from 'react';

import { useHasLoggedOut } from '../../context/AuthMachine';
import { clearGroupOrderReference } from '../useGroupOrderingState/group-order-reference-storage';

// ─────────────────────────────────────────────────────────────────────────────

export const useResetGroupOrderReferenceOnLogout = () => {
  const hasLoggedOut = useHasLoggedOut();

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const handleLogout = useCallback(() => {
    if (!hasLoggedOut) return;

    clearGroupOrderReference();
  }, [hasLoggedOut]);

  // ─── Effects ───────────────────────────────────────────────────────────────

  useEffect(handleLogout, [handleLogout]);
};
